import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

const CookieConsent: React.FC = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      setShowBanner(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
  };

  const rejectCookies = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setShowBanner(false);
  };

  return (
    <AnimatePresence>
      {showBanner && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.5 }}
          className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-2xl"
        >
          <div className="container mx-auto px-4 py-6">
            <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-4">
              <div className="flex-1">
                <h3 className="text-lg font-serif font-bold text-inkavida-black mb-2">
                  Política de Cookies
                </h3>
                <p className="text-sm text-gray-700 font-sans leading-relaxed">
                  Utilizamos cookies para mejorar tu experiencia en nuestro sitio web. 
                  Al continuar navegando, aceptas nuestro uso de cookies.{' '}
                  <Link 
                    to="/cookies" 
                    className="text-inkavida-orange hover:text-inkavida-green font-semibold underline"
                  >
                    Leer más sobre nuestra política de cookies
                  </Link>
                </p>
              </div>
              <div className="flex items-center gap-3">
                <button
                  onClick={rejectCookies}
                  className="px-6 py-2 border border-gray-300 text-gray-700 rounded-full font-sans font-semibold text-sm hover:bg-gray-50 transition-colors duration-300"
                >
                  Rechazar
                </button>
                <button
                  onClick={acceptCookies}
                  className="px-6 py-2 bg-inkavida-orange text-white rounded-full font-sans font-semibold text-sm hover:bg-inkavida-orange/90 transition-colors duration-300"
                >
                  Aceptar
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieConsent;